import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import { useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'
import React from 'react'

const BlockedCartPopup: React.FC = () => {
  const config = useReduxSelector(selectConfig)
  const { t } = useTranslation('basic')
  const { goBack } = useHistory()
  return (
    <Popup>
      <div className='blockedCart__popup'>
        <div className='popup__title'>
          <div>{config?.blockedCart?.title}</div>
          <div>{config?.blockedCart?.content}</div>
        </div>
        <ArrowBtn
          enlarged
          text={t('close')}
          action={goBack}
        />
      </div>
    </Popup>
  )
}

export default BlockedCartPopup